import axios from 'axios';

import {
  getHeaders,
} from './Utils';

import {
  ENDPOINT_FILEREAD_AUDIO,
} from './constants';

export default class Audio {
  static getAudioFile(filepath) {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: ENDPOINT_FILEREAD_AUDIO,
      data: {
        audiofile: filepath,
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/Audio.js